<ng-container *ngIf="unika && this.buildType !== 'office'">
    <ul class="flat" (mouseenter)="hightlightFloorPlan(flat, 'add')" (mouseleave)="hightlightFloorPlan(flat, 'remove')"
        [class.selected]="flat === selectedFlat" [attr.data-index]="flat.number" [attr.data-numroom]="flat.numberOfRooms" [class.hover-plan]="flat.number === currentUnitNumber">
        <li>
            <!-- <button (click)="goToHotspotAnotherScene()">testHot</button> -->
            <div *ngIf="this.user">
                <div
                        *ngIf="!this.sehelUser && this.desktopResolution && this.user.compId === this.build.compId  || this.user.roles.admin || this.user.roles.manager"
                        class="edit-client-status">
                    <a *ngIf="this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin || this.user.roles.manager"
                       (click)='editItem($event, flat)' href='javascript:;' class="fa fa-pencil fa-lg"></a>
                </div>
            </div>
            <a (click)='showFlatProperties($event, flat)' (mouseenter)="showHotspot(flat)"
               [class.active]="additionalProperties && this.currentFlatId === flat.id && !desktopResolution"
               [class.disabled]="flat.status === 'sold' || flat.status === 'disabled' || flat.status === 'notForSale'"
               class="{{ flat.status }} {{ flat.color }} {{ flat.snffnames }}" href="javascript:;"
               [class.hiden-room-number]="!hideRoomNumberProperty">
                <span *ngIf="(!flat.withDrawing && this.buildType !== 'office') || this.buildType === 'housing'" class="floorPlanTrigger">{{ flat.floorNumber }}</span>
                <span *ngIf="flat.withDrawing && this.buildType !== 'office' && this.buildType !== 'housing'" class="floorPlanTrigger withDrawing"><button
                        (click)="showFloorPlanF($event, flat.number)">{{ flat.floorNumber }}</button></span>




                <!-- check is Items START -->
                <!--        <app-gallery [galleryId]="'1'" [checkIfItems]="true" [section]="item.id +'interiorSimulations'"
                          [autoPlay]="true" [showThumbs]="true" class="list-static flat-details scroll hidden"
                          (isNoItems)="isNoItemsF($event, item, 'simpleGallery')"></app-gallery>

                        <app-gallery *ngIf="item.faltPrototypeId" [checkIfItems]="true" [galleryId]="'1'"
                          [section]="item.faltPrototypeId+'interiorSimulations'" [autoPlay]="true" [showThumbs]="true"
                          class="list-static flat-details scroll hidden"
                          (isNoItems)="isNoItemsF($event, item, 'simpleGallery')"></app-gallery>-->
                <!-- check is Items END -->



                <!-- //test floors plans START -->
                <div class="floor-drowing-holder" *ngIf="flat.withDrawing && showFloorPlan && itemToShow == flat.number"
                     (click)="prevent($event)">
                    <a class="close-section close-floor-plan" (click)="closeFloorDrawing($event)"></a>
                    <app-drawing-floors *ngIf="flat.withDrawing && showFloorPlan && itemToShow == flat.number" class="floor-gallery"
                                        [drawingHolderWidth]="1000" [item]="flat.floorId"></app-drawing-floors>
                </div>
                <!-- //test floors plans end -->


                <span class="flat-number-unika">{{ flat.number }} <span class="meshtaken"
                                                                        [class.hide]="!flat.meshtaken">מ</span>
          <span class="app-name" *ngIf="flat.name !== '' && flat.name">{{ flat.name }}</span>
        </span>
                <span class="num-rooms-unika"
                      *ngIf="flat.numberOfRooms && hideRoomNumberProperty && this.buildType !== 'office'">{{ flat.numberOfRooms
                    }}<strong>{{ 'ROOM' | translate
                        }}</strong></span>
                <span class="num-rooms-unika"
                      *ngIf="flat.numberOfRooms && hideRoomNumberProperty && this.buildType === 'office'">{{ flat.balconiesSize
                    }}</span>
                <span class="num-rooms-unika"
                      *ngIf="flat.numberOfRooms && hideRoomNumberProperty && this.buildType === 'office'">{{ flat.shelterArea
                    }}</span>

                <span *ngIf="this.wholeNum && flat.flatSize">{{ flat.flatSize | wholeNum }}</span>
                <span *ngIf="!this.wholeNum && flat.flatSize">{{ flat.flatSize | formatSqm: currentLanguage }}</span>

                <span *ngIf="this.wholeNum && !flat.flatSize">0</span>
                <span *ngIf="!this.wholeNum && !flat.flatSize">0</span>
                <span *ngIf="!this.sehelUser" [ngSwitch]="flat.status" class="flag-holder">
          <span class="flag red" *ngSwitchCase="'sold'">{{ 'SOLD' | translate }}</span>
          <span class="flag yellow" *ngSwitchCase="'waiting'">{{ 'IN-REGISTRATION' | translate }}</span>
          <span class="flag disabled not-for-sale" *ngSwitchCase="'notForSale'"> לא למכירה </span>
          <span class="flag green" *ngSwitchDefault>{{ 'FREE' | translate }}</span>
        </span>
                <span class="proto-name" *ngIf="flat.prototypeName && this.build.showProto">{{ flat.prototypeName }}</span>
                <span *ngIf="this.sehelUser" class="like">
          <a href="javascript:;" (click)="likeUnlike($event, flat)" [class.hightlight]="ifLike(flat)"></a>
        </span>

                <div *ngIf="flat.status === 'sold' && !this.sehelUser" class="sold-title">{{ 'SOLD' | translate }}</div>
            </a>

            <!-- <span class="is-virtual-tour" *ngIf="flat.isVirtualTour"></span> -->
            <span class="is-interior-gal" *ngIf="simpleGallery"></span>
        </li>
        <li *ngIf="this.user && this.desktopResolution" class="edit-popup-holder">
            <div
                    *ngIf="this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin || this.user.roles.manager">
                <div *ngIf="editState && itemToEdit.id == flat.id" class="edit-popup">
                    <a class="close-section" href="javascript:;" (click)='closeEdit()'></a>
                    <h5>עריכת דירה</h5>
                    <form (ngSubmit)='updateItem(flat)'>
                        <label>סטאטוס:
                            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                                             [(ngModel)]="flat.status" name="flatstatus" (change)="onRadioChange($event)">
                                <mat-radio-button class="example-radio-button" *ngFor="let flatstatus of flatstatuss"
                                                  [value]="flatstatus">
                                    <ng-container [ngSwitch]="flatstatus">
                                        <div *ngSwitchCase="'free'">פנוי</div>
                                        <div *ngSwitchCase="'waiting'">בהמתנה</div>
                                        <span *ngSwitchCase="'notForSale'">לא למכירה</span>
                                        <div *ngSwitchCase="'sold'">נמכר</div>
                                    </ng-container>
                                </mat-radio-button>
                            </mat-radio-group>
                        </label>


                        <input type="submit" value="ערוך" class="btn">
                    </form>

                </div>
            </div>
        </li>
        <!-- <li *ngIf="this.user && this.desktopResolution" class="edit-client-status">
          <a *ngIf="this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin" (click)='editItem($event, item)' href='javascript:;'
            class="fa fa-pencil fa-lg"></a>
        </li> -->
        <!-- <span class="question" (click)=showCurrentExplanation($event)>?</span>
          <div class="explanation">
            <div class="all-wrapper"></div>
            <span class="close-explanation" (click)="closeExplanation()"></span>
            <span class="step-number">5</span>
            <span class="text">
              לורם איפסום הוא כינוי
            </span>
            <div class="explanation-nav">
              <button class="btn prev-step" (click)="prevnextF($event, 'next')">הבאה</button>
              <button class="btn next-step" (click)="prevnextF($event, 'prev')">קודם</button>
            </div>
          </div> -->
    </ul>
</ng-container>

<ng-container *ngIf="unika && this.buildType === 'office'">
    <ul @slideUp class="flat" (mouseenter)="hightlightFloorPlan(flat, 'add')" (mouseleave)="hightlightFloorPlan(flat, 'remove')"
        [class.selected]="flat === selectedFlat" [attr.data-index]="flat.number" [attr.data-numroom]="flat.numberOfRooms"
        [class.hover-plan]="flat.number === currentUnitNumber">
        <li>
            <!-- <button (click)="goToHotspotAnotherScene()">testHot</button> -->
            <div *ngIf="this.user">
                <div
                        *ngIf="!this.sehelUser && this.desktopResolution && this.user.compId === this.build.compId  || this.user.roles.admin || this.user.roles.manager"
                        class="edit-client-status">
                    <a *ngIf="this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin || this.user.roles.manager"
                       (click)='editItem($event, flat)' href='javascript:;' class="fa fa-pencil fa-lg"></a>
                </div>
            </div>
            <a (click)='showFlatProperties($event, flat)' (mouseenter)="showHotspot(flat)"
               [class.active]="additionalProperties && this.currentFlatId === flat.id && !desktopResolution"
               [class.disabled]="flat.status === 'sold' || flat.status === 'disabled' || flat.status === 'notForSale'"
               class="{{ flat.status }} {{ flat.color }} {{ flat.snffnames }}" href="javascript:;"
               [class.hiden-room-number]="!hideRoomNumberProperty">

        <span class="flat-number-unika">{{ flat.number }} <span class="meshtaken"
                                                                [class.hide]="!flat.meshtaken">מ</span>
          <span class="app-name" *ngIf="flat.name !== '' && flat.name">{{ flat.name }}</span>
        </span>
                <span *ngIf="!this.wholeNum && flat.flatSize">{{ flat.flatSize | formatSqm: currentLanguage }}</span>
                <span class="num-rooms-unika" *ngIf="flat.numberOfRooms && hideRoomNumberProperty">{{ flat.balconiesSize
                    }}</span>
                <span class="num-rooms-unika" *ngIf="flat.numberOfRooms && hideRoomNumberProperty">{{ flat.shelterArea }}</span>

                <span *ngIf="this.wholeNum && flat.flatSize">{{ flat.flatSize | wholeNum }}</span>


                <span *ngIf="this.wholeNum && !flat.flatSize">0</span>
                <span *ngIf="!this.wholeNum && !flat.flatSize">0</span>
                <span *ngIf="!this.sehelUser" [ngSwitch]="flat.status" class="flag-holder">
          <span class="flag red" *ngSwitchCase="'sold'">{{ 'SOLD' | translate }}</span>
          <span class="flag yellow" *ngSwitchCase="'waiting'">{{ 'IN-REGISTRATION' | translate }}</span>
          <span class="flag disabled not-for-sale" *ngSwitchCase="'notForSale'"> לא למכירה </span>
          <span class="flag green" *ngSwitchDefault>{{ 'FREE' | translate }}</span>
        </span>
                <span class="proto-name" *ngIf="flat.prototypeName && this.build.showProto">{{ flat.prototypeName }}</span>
                <span *ngIf="this.sehelUser" class="like">
          <a href="javascript:;" (click)="likeUnlike($event, flat)" [class.hightlight]="ifLike(flat)"></a>
        </span>

                <div *ngIf="flat.status === 'sold' && !this.sehelUser" class="sold-title">{{ 'SOLD' | translate }}</div>
            </a>
        </li>
        <li *ngIf="this.user && this.desktopResolution" class="edit-popup-holder">
            <div
                    *ngIf="this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin || this.user.roles.manager">
                <div *ngIf="editState && itemToEdit.id == flat.id" class="edit-popup">
                    <a class="close-section" href="javascript:;" (click)='closeEdit()'></a>
                    <h5>עריכת דירה</h5>
                    <form (ngSubmit)='updateItem(flat)'>
                        <label>סטאטוס:
                            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                                             [(ngModel)]="flat.status" name="flatstatus">
                                <mat-radio-button class="example-radio-button" *ngFor="let flatstatus of flatstatuss"
                                                  [value]="flatstatus">
                                    <container-element [ngSwitch]="flatstatus">
                                        <div *ngSwitchCase="'free'">פנוי</div>
                                        <div *ngSwitchCase="'waiting'">בהמתנה</div>
                                        <span *ngSwitchCase="'notForSale'"> לא למכירה </span>
                                        <div *ngSwitchCase="'sold'">נמכר</div>
                                    </container-element>
                                </mat-radio-button>
                            </mat-radio-group>
                        </label>
                        <input type="submit" value="ערוך" class="btn">
                    </form>
                </div>
            </div>
        </li>
    </ul>
</ng-container>

